import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/agents')({
  component: AgentsLayout,
});

function AgentsLayout() {
  // This is a layout route - it should render the Outlet for child routes
  return <Outlet />;
}
